import ReactGA from 'react-ga4';

const TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID || 'G-XXXXXXXXXX';

export const initGA = () => {
  if (TRACKING_ID !== 'G-XXXXXXXXXX') {
    ReactGA.initialize(TRACKING_ID);
    console.log('Google Analytics initialized');
  }
};

export const logPageView = (path) => {
  ReactGA.send({ hitType: 'pageview', page: path });
};

export const logEvent = (category, action, label) => {
  ReactGA.event({
    category: category,
    action: action,
    label: label
  });
};

export const logConversion = (value, currency = 'USD') => {
  ReactGA.event({
    category: 'Conversion',
    action: 'Purchase',
    value: value,
    currency: currency
  });
};
